import React from 'react';
import Card from '../ui/Card';
import { AlertOctagonIcon, ShieldAlertIcon, KeyRoundIcon, RotateCcwIcon, ServerCrashIcon } from 'lucide-react';
import { DashboardFilters } from '../../pages/Dashboard';
const baseRisks = [{
  label: 'Failed Transactions',
  baseValue: 1124,
  trend: '↑2.3%',
  icon: AlertOctagonIcon,
  color: 'text-rose-600 dark:text-rose-400',
  bg: 'bg-rose-100 dark:bg-rose-900/30',
  border: 'border-rose-200 dark:border-rose-800/50'
}, {
  label: 'High Risk Transactions',
  baseValue: 89,
  trend: null,
  icon: ShieldAlertIcon,
  color: 'text-orange-600 dark:text-orange-400',
  bg: 'bg-orange-100 dark:bg-orange-900/30',
  border: 'border-orange-200 dark:border-orange-800/50'
}, {
  label: 'OTP Failures (3DS/RAAST)',
  baseValue: 234,
  trend: null,
  icon: KeyRoundIcon,
  color: 'text-amber-600 dark:text-amber-400',
  bg: 'bg-amber-100 dark:bg-amber-900/30',
  border: 'border-amber-200 dark:border-amber-800/50'
}, {
  label: 'Reversals / Chargebacks',
  baseValue: 67,
  trend: null,
  icon: RotateCcwIcon,
  color: 'text-indigo-600 dark:text-indigo-400',
  bg: 'bg-indigo-100 dark:bg-indigo-900/30',
  border: 'border-indigo-200 dark:border-indigo-800/50'
}, {
  label: 'System Errors',
  baseValue: 12,
  trend: null,
  icon: ServerCrashIcon,
  color: 'text-red-600 dark:text-red-400',
  bg: 'bg-red-100 dark:bg-red-900/30',
  border: 'border-red-200 dark:border-red-800/50'
}];
const timeMultipliers = {
  Today: 1,
  Week: 7,
  MTD: 22,
  YTD: 265
};
interface RiskMonitoringProps {
  filters: DashboardFilters;
}
export const RiskMonitoring: React.FC<RiskMonitoringProps> = ({
  filters
}) => {
  const {
    timeRange
  } = filters;
  const timeMult = timeMultipliers[timeRange];
  const risks = baseRisks.map(risk => ({
    ...risk,
    value: Math.round(risk.baseValue * timeMult).toLocaleString()
  }));
  return <Card title="Risk & Monitoring" className="h-full" data-id="element-222">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-223">
        {risks.map((risk, idx) => {
        const Icon = risk.icon;
        return <div key={idx} className={`flex items-center p-4 rounded-xl border bg-white dark:bg-slate-800/50 shadow-sm hover:shadow-md transition-shadow ${risk.border} ${idx === 0 ? 'sm:col-span-2 bg-rose-50/30 dark:bg-rose-900/10' : ''}`} data-id="element-224">
              <div className={`p-3 rounded-xl ${risk.bg} mr-4 ring-1 ring-white/50 dark:ring-black/20 shadow-sm`} data-id="element-225">
                <Icon className={`h-6 w-6 ${risk.color}`} strokeWidth={2.5} data-id="element-226" />
              </div>
              <div className="flex-1" data-id="element-227">
                <p className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1" data-id="element-228">
                  {risk.label}
                </p>
                <div className="flex items-baseline space-x-3" data-id="element-229">
                  <span className="text-2xl font-bold text-slate-900 dark:text-white tracking-tight" data-id="element-230">
                    {risk.value}
                  </span>
                  {risk.trend && <span className="text-[11px] font-bold text-rose-700 dark:text-rose-400 bg-rose-100 dark:bg-rose-900/50 px-2 py-0.5 rounded-md border border-rose-200 dark:border-rose-800" data-id="element-231">
                      {risk.trend}
                    </span>}
                </div>
              </div>
            </div>;
      })}
      </div>
    </Card>;
};